export const educationData = [
    {
        id: 1,
        institution: 'Amrita Vishwa Vidyapeetham',
        course: 'Master Computer Application',
        startYear: '2022',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'Dr G R Damodaran College of Science',
        course: 'Bachelor of Science',
        startYear: '2018',
        endYear: '2020'
    },
    
    {
        id: 3,
        institution: 'AVB Matric Higher Secondary School',
        course: 'Higher Secondary Education',
        startYear: '2016',
        endYear: '2018'
    },
    
]